import React from 'react';
import PropTypes from 'prop-types';

import BizCard from '../../components/UI/BizCard';

import { currencyFormat } from '../../utils/globals';

const immovableRow = (entry) => (
  <tr key={entry.id}>
    <td>
      Mortgage of <strong>{entry.propertyType}</strong> situated at <strong>{entry.address}, {entry.city}, {entry.state} - {entry.pincode}</strong>,
      Measuring land area of <strong>{entry.plotArea}</strong> and construction of <strong>{entry.constructionArea}</strong> sq. ft.
      owned by <strong>{entry.ownedBy}</strong>
    </td>
    <td>{entry.product}</td>
    <td>{currencyFormat(entry.marketValue)}</td>
    <td>{entry.chargeNature}</td>
  </tr>
);

const movableRow = (entry) => (
  <tr key={entry.id}>
    <td>{entry.details}</td>
    <td>{entry.product}</td>
    <td>{currencyFormat(entry.marketValue)}</td>
    <td>{entry.chargeNature}</td>
  </tr>
);

const LdsFisView = (props) => {
  const { movableSecurities, immovableSecurities, queries } = props.fis;

  return (
    <BizCard title="Further Information Sheet">
      <table className="biz-form-table">
        <tbody>
          {
            immovableSecurities && immovableSecurities.length > 0 ?
              [
                <tr key="primary">
                  <td className="biz-form-table-label">Primary Immovable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th>Product</th>
                          <th>Market Value</th>
                          <th>Nature of charge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          immovableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                            immovableRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>,
                <tr key="collateral">
                  <td className="biz-form-table-label">Collateral Immovable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th>Product</th>
                          <th>Market Value</th>
                          <th>Nature of charge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          immovableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                            immovableRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>,
              ]
              :
              null
          }

          {/* Movalble securities */}
          {
            movableSecurities && movableSecurities.length > 0 ?
              [
                <tr key="primary">
                  <td className="biz-form-table-label">Primary Movable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th>Product</th>
                          <th>Market Value</th>
                          <th>Nature of charge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          movableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                            movableRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>,
                <tr key="collateral">
                  <td className="biz-form-table-label">Collateral Immovable Security</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th>Product</th>
                          <th>Market Value</th>
                          <th>Nature of charge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          movableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                            movableRow(entry)
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>,
              ]
              :
              null
          }

          {/* Additional Details */}
          {
            queries && queries.length > 0 ?
              <tr>
                <td className="biz-form-table-label">Queries</td>
                <td className="biz-form-table-input">
                  <table className="biz-data-table biz-bordered">
                    <thead>
                      <tr>
                        <th>Query</th>
                        <th>Reply</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        queries.map((entry) => (
                          <tr key={entry.id}>
                            <td>{entry.query}</td>
                            <td>{entry.reply}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
              </tr>
              :
              null
          }

        </tbody>
      </table>
    </BizCard>
  );
};

LdsFisView.propTypes = {
  fis: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default LdsFisView;



// WEBPACK FOOTER //
// ./src/pages/leads/LdsFisView.jsx